<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-columns"></i> Tipo de Despesas - Followup</h3>
      </div>
    </div>
    <ExpenseTypeAdd v-if="showAdd" ref="ExpenseTypeAdd" @Back="onBack" />
    <ExpenseTypeList v-else ref="ExpenseTypeList" @New="onNew" @Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ExpenseTypeAdd from './components/add/expenseTypeAdd.vue'
import ExpenseTypeList from './components/list/expenseTypeList.vue'

export default {
  name: 'ExpenseType',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ExpenseTypeAdd,
    ExpenseTypeList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ExpenseTypeAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/expenseType/expenseType.vue